<template>
  <div class="mb-4">
    <div>
      <h3 v-if="step == 'attempt'">Thông tin đăng nhập</h3>
      <h3 v-if="step == 'qrcode'">Quét mã QRCode</h3>
      <h3 v-if="step == 'otp2fa'">Xác thực mã 2-FA</h3>
    </div>
  </div>

  <div v-if="!user">
    <form autocomplete="off" @submit="onSignIn($event)" v-if="step == 'attempt'">
      <div>
        <label>Email</label>
        <input class="form-control" type="text" placeholder="Nhập địa chỉ email" v-model="signInForm.email" :class="{ 'border-danger': signInForm.errors.email }"/>
        <div class="msg-error" v-if="signInForm.errors.email">{{ signInForm.errors.email[0] }}</div>
      </div>

      <div class="mt-3">
        <label>Mật khẩu</label>
        <input class="form-control" type="password" placeholder="Nhập mật khẩu" v-model="signInForm.password" :class="{ 'border-danger': signInForm.errors.password }"/>
        <div class="msg-error" v-if="signInForm.errors.password">{{ signInForm.errors.password[0] }}</div>
      </div>

      <div class="mt-3 alert alert-danger msg" v-if="signInForm.message">{{ signInForm.message }}</div>

      <div class="mt-4">
        <button class="btn btn-success" style="width: 100%" type="submit">
          <div v-if="signInForm.isLoading" class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only"></span>
          </div> Đăng nhập
        </button>
      </div>
    </form>

    <div v-if="step == 'qrcode'">
      <div class="qrcode">
        <div>Bạn chưa cài đặt 2-FA, Vui lòng sử dụng ứng dụng authenticator để quét mã</div>
        <div><img :src="verifySignInForm.qrcode"/></div>
      </div>

      <div class="mt-4">
        <button class="btn btn-success" style="width: 100%" @click="nextStep('otp2fa')">
          Đã quét mã
        </button>
      </div>
    </div>

    <form autocomplete="off" @submit="onVerifySignIn($event)" v-if="step == 'otp2fa'">
      <div>
        <label>Mã xác thực</label>
        <input class="form-control" type="text" placeholder="Verify code" v-model="verifySignInForm.code"
          :class="{ 'border-danger': verifySignInForm.errors.code }">
        <div class="msg-error" v-if="verifySignInForm.errors.code">{{ verifySignInForm.errors.code[0] }}</div>
      </div>

      <div class="mt-4">
        <button class="btn btn-success" style="width: 100%" type="submit">
          <div v-if="verifySignInForm.isLoading" class="spinner-border spinner-border-sm" role="status">
            <span class="sr-only"></span>
          </div> Xác thực
        </button>
      </div>
    </form>
  </div>

  <div v-else class="text-center">
    <div v-if="isRedirecting" class="spinner-border" role="status">
      <span class="sr-only"></span>
    </div>
  </div>

  <div class="mt-4" v-if="step == 'attempt'">
    <div><a href="javascript: void(0)" @click="$emit('return', 'forget')">Quên mật khẩu?</a></div>
  </div>
</template>


<style lang="scss" scoped>
label {
  font-size: 0.8rem;
  margin-bottom: 2px;
}

h3{
  font-size: 1.2rem;
  text-align: center;
}

.qrcode{
  & > div:first-child{
    font-size: 0.9rem;
    margin-bottom: 20px;
  }

  img{
    border-radius: 8px;
    border: 7px solid #4d77a4;
    margin: 0px 0 20px;
    width: 200px;
  }

  & > div:last-child{
    text-align: center;
  }
}

.msg{
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  background-color: transparent;
  color: #f5c2c7;
}
</style>

<script>
export default {
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },

  data() {
    return {
      step: 'attempt',
      signInForm: this.getSignInForm(),
      isRedirecting: false,
      verifySignInForm: this.getVerifySignInForm()
    }
  },

  methods: {
    getSignInForm() {
      return {
        isLoading: false,
        errors: {},
        email: '',
        password: ''
      };
    },

    getVerifySignInForm() {
      return {
        isLoading: false,
        errors: {},
        code: '',
        attempt_token: '',
        qrcode: ''
      };
    },

    async onSignIn(e) {
      e.preventDefault();
      this.verifySignInForm = this.getVerifySignInForm();
      this.signInForm.isLoading = true;
      let res = await this.$api.auth.attempt({
        password: this.signInForm.password,
        email: this.signInForm.email
      }).call();

      this.signInForm.isLoading = false;
      let result = res.response.result;

      if (res.success) {
        if (result.next == 'contact') {
          this.$store.dispatch('confirmation/open', {
            title: 'Liên hệ admin',
            type: 'info',
            message: this.$msg(result.message),
            options: [
              {
                name: 'ok',
                label: 'OK',
                variant: 'primary'
              }
            ]
          });
          return;
        }

        this.verifySignInForm.qrcode = result.qrcode_url;
        this.verifySignInForm.attempt_token = result.attempt_token;
        if (result.qrcode_url) {
          this.step = 'qrcode';
        } else {
          this.step = 'otp2fa';
        }
      } else {
        this.signInForm.errors = result?.errors || {};
        if (result.message) {
          this.$store.dispatch('confirmation/open', {
            title: 'Thông báo',
            type: 'info',
            message: this.$msg(result.message),
            options: [
              {
                name: 'ok',
                label: 'OK',
                variant: 'primary'
              }
            ]
          });
        }
      }
    },

    async onVerifySignIn(e) {
      e.preventDefault();
      this.verifySignInForm.isLoading = true;
      let res = await this.$api.auth.verify({
        attempt_token: this.verifySignInForm.attempt_token,
        code: this.verifySignInForm.code
      }).call();

      this.verifySignInForm.isLoading = false;
      let result = res.response.result;

      if (res.success) {
        this.$store.dispatch('auth/login', {token: 'Bearer ' + result.access_token}).then(() => {
          this.$router.push('/');
        });
      } else {
        this.verifySignInForm.errors = result.errors;
      }
    },

    async nextStep(step) {
      this.step = step;
    }
  }
}
</script>